<template>
  <div class="popup z-index-10-fg confirmation small-popup add-interaction-popup">
    <div class="popup-content">
      <div class="popup-header">
        <h2>Report Filters</h2>
        <img src="../assets/close.svg" alt="" class="popup-close" @click="$emit('closePopup')" />
      </div>
      <div class="popup-body">
        <MultiDropdown :options="sourceOptions" label="Source" :showSelectAll="true" v-model="filters.source" class="input-item" />
        <MultiDropdown :options="channelOptions" label="Channel" :showSelectAll="true" v-model="filters.channel" class="input-item" />
        <MultiDropdown :options="channelDrilldown1Options" label="Channel Drilldown 1" :showSelectAll="true" v-model="filters.channelDrilldown1" class="input-item" />
        <MultiDropdown :options="channelDrilldown2Options" label="Channel Drilldown 2" :showSelectAll="true" v-model="filters.channelDrilldown2" class="input-item" />
        <TextBox label="Date From" v-model="filters.startDate" type="date" class="input-item small-item" />
        <TextBox label="Date To" v-model="filters.endDate" type="date" class="input-item small-item" />
        <Dropdown :options="statusOptions" label="Status" v-model="filters.status" class="input-item small-item" />
      </div>
      <div class="popup-footer">
        <button @click="resetFilters" class="text-btn">reset filters</button>
        <button @click="$emit('closePopup')" class="text-btn">close</button>
        <button :class="{ 'square-btn': true, saving: loading }" @click="saveAndRun" :disabled="loading">save & run <img src="../assets/spinner.svg" /></button>
      </div>
    </div>
  </div>
  <div class="screen-overlay-gray z-index-10-bg"></div>
</template>

<script>
import MultiDropdown from './inputs/MultiDropdown.vue';
import Dropdown from './inputs/Dropdown.vue';
import TextBox from './inputs/TextBox.vue';
import { useSalesImpactReportQuery, useSalesImpactReportFilters } from '@/composables/useSalesImpactReportQuery';
import usePicklistItemsQuery from '@/composables/usePicklistItemsQuery';

export default {
  name: 'SalesImpactReportFilter',
  emits: ['closePopup'],
  components: {
    MultiDropdown,
    Dropdown,
    TextBox,
  },
  setup() {
    const { filters, columnsList, runReport, loading, resetFilters } = useSalesImpactReportQuery();
    const { filterOptions } = useSalesImpactReportFilters();
    const { pickLists } = usePicklistItemsQuery;

    return {
      filters,
      columnsList,
      runReport,
      pickLists,
      loading,
      resetFilters,
      filterOptions,
      statusOptions: [
        { text: 'All', value: 'all' },
        { text: 'Open', value: 'open' },
        { text: 'Closed', value: 'closed' },
      ],
    };
  },
  computed: {
    sortedColumnsList() {
      return this.columnsList.sort((a, b) => a.order - b.order).map((item) => ({ key: item.name, value: item.title }));
    },
    sourceOptions() {
      return this.filterOptions.filter((option) => option.FILTERTYPE === 'SOURCE').map((option) => ({ key: option.NAME, value: option.NAME }));
    },
    channelOptions() {
      return this.filterOptions.filter((option) => option.FILTERTYPE === 'CHANNEL').map((option) => ({ key: option.NAME, value: option.NAME }));
    },
    channelDrilldown1Options() {
      return this.filterOptions.filter((option) => option.FILTERTYPE === 'CHANNEL DRILLDOWN 1').map((option) => ({ key: option.NAME, value: option.NAME }));
    },
    channelDrilldown2Options() {
      return this.filterOptions.filter((option) => option.FILTERTYPE === 'CHANNEL DRILLDOWN 2').map((option) => ({ key: option.NAME, value: option.NAME }));
    },
  },
  methods: {
    saveAndRun() {
      this.$emit('closePopup');
      this.runReport();
    },
  },
};
</script>

<style lang="scss" scoped>
.add-interaction-popup {
  width: 35rem;
  max-height: 85vh;
  overflow-y: auto;

  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  .popup-body {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1.5rem 1rem;

    .input-item {
      min-width: 10rem;
      flex: 1 0 45%;

      &.small-item {
        min-width: 5rem;
        flex: 1 0 30%;
      }

      &.large-item {
        min-width: 15rem;
        flex: 1 0 75%;
      }
    }
  }
}
</style>
